import Vue from 'vue'
import SignaturePad from 'signature_pad'

Vue.prototype.$SignaturePad = SignaturePad
